import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import ListMarketingByGetMarketing from "./ListMarketingByGetMarketing";

function CabangKunjunganMarketing() {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [sendDataMarketing, setSendDataMarketing] = React.useState([]);
  const [sendDataCabang, setSendDataCabang] = React.useState([]);

  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_MARKETING", data: false });
    setSendDataMarketing(val.marketing);
    setSendDataCabang(val.cabang);
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  React.useEffect(() => {
    if (kunjungan.dataGetMarketing) {
      let tmp = kunjungan.dataGetMarketing.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`t-detail-cabang-${val.kodeCabang}`}>
                    Lihat Detail Cabang
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#E0F2FE", // Soft Blue
                    border: "1px solid #BAE6FD",
                    color: "#0369A1",
                    transition: "all 0.2s ease",
                    marginTop: 5,
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#0369A1";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#E0F2FE";
                    e.currentTarget.style.color = "#0369A1";
                  }}
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
      setListDataMarketing(tmp);
    }
  }, [kunjungan.dataGetMarketing]);

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F1F5F9",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#475569",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        "&:hover": {
          backgroundColor: "#F8FAFC",
          cursor: "pointer",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#1E293B",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "NO",
      width: "70px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      style: { fontWeight: "bold", color: "#94A3B8" },
    },
    {
      name: "KODE CABANG",
      minWidth: "150px",
      center: true,
      cell: (row) => (
        <span className="badge bg-light text-dark border px-3 py-2">
          {row.kodeCabang}
        </span>
      ),
    },
    {
      name: "NAMA CABANG",
      minWidth: "220px",
      selector: (row) => row.namaCabang,
      style: { fontWeight: "700" },
    },
    {
      name: "AKTIVITAS KUNJUNGAN",
      minWidth: "200px",
      center: true,
      cell: (row) => (
        <div className="text-center">
          <span className="text-primary fw-800" style={{ fontSize: "15px" }}>
            {row.totalKunjungan}
          </span>
          <div className="text-muted small">Kunjungan Terdaftar</div>
        </div>
      ),
    },
    {
      name: "SUMBER DAYA",
      minWidth: "200px",
      center: true,
      cell: (row) => (
        <div className="text-center">
          <span className="text-dark fw-800" style={{ fontSize: "15px" }}>
            {row.marketing.length}
          </span>
          <div className="text-muted small">Personel Marketing</div>
        </div>
      ),
    },
    {
      name: "AKSI",
      width: "100px",
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center">{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      idCabang: idCabang,
      idMarketing: idMarketing,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir]);

  return (
    <>
      {kunjungan.detailGetMarketing ? (
        <Container fluid className="py-4">
          <Row>
            <Col md="12">
              <Card className="border-0 shadow-sm rounded-xl">
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h3
                        className="fw-800 text-dark m-0"
                        style={{ letterSpacing: "1px" }}
                      >
                        LIST KUNJUNGAN CABANG
                      </h3>
                      <p className="text-muted small mb-0">
                        Monitor aktivitas kunjungan harian berdasarkan rentang
                        waktu tertentu.
                      </p>
                    </div>
                    {/* Legend/Info Badge */}
                    <div className="bg-light-blue px-3 py-2 rounded-pill border border-info-subtle">
                      <span className="text-primary fw-bold small">
                        <i className="far fa-calendar-check mr-2"></i>
                        Filter Periode Aktif
                      </span>
                    </div>
                  </div>

                  {/* FILTER TOOLBAR: Date Range Picker Style */}
                  <div className="bg-light p-3 rounded-xl border-0 mt-3 shadow-inner">
                    <Row className="align-items-end g-3">
                      <Col md={3} sm={6}>
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          <i className="fas fa-calendar-alt mr-2 text-primary"></i>
                          Tanggal Awal
                        </label>
                        <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                          <ReactDatetime
                            inputProps={{
                              className: "form-control border-0 bg-transparent",
                              placeholder: "Pilih Tanggal",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                fontWeight: "600",
                                color: "#334155",
                              },
                            }}
                            onChange={(e) => {
                              const date = e.toDate
                                ? e.toDate().setHours(0, 0, 0, 0)
                                : e;
                              setTglAwal(date);
                            }}
                            value={tglAwal}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </Col>

                      <Col md={3} sm={6}>
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          <i className="fas fa-calendar-check mr-2 text-primary"></i>
                          Tanggal Akhir
                        </label>
                        <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                          <ReactDatetime
                            inputProps={{
                              className: "form-control border-0 bg-transparent",
                              placeholder: "Pilih Tanggal",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                fontWeight: "600",
                                color: "#334155",
                              },
                            }}
                            onChange={(e) => {
                              const date = e.toDate
                                ? e.toDate().setHours(0, 0, 0, 0)
                                : e;
                              setTglAkhir(date);
                            }}
                            value={tglAkhir}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </Col>

                      <Col md="auto" sm={12} className="ml-md-2 mt-3 mt-md-0">
                        <Button
                          className="px-4 fw-800 shadow-sm border-0 d-flex align-items-center"
                          style={{
                            backgroundColor: "#577d86",
                            borderRadius: "10px",
                            height: "46px",
                            color: "white",
                          }}
                          onClick={() => {
                            /* Trigger filter logic if any */
                          }}
                        >
                          <i className="fas fa-sync-alt mr-2"></i> UPDATE DATA
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Card.Header>

                <Card.Body className="px-4 pb-4 mt-2">
                  {isLoading ? (
                    <div className="py-5 text-center d-flex flex-column align-items-center">
                      <Watch height="70" width="70" color="#577d86" />
                      <h5 className="mt-4 fw-600 text-muted animate-pulse">
                        Sinkronisasi Data Cabang...
                      </h5>
                    </div>
                  ) : (
                    <div className="table-responsive-custom">
                      <DataTable
                        columns={colKunjungan}
                        data={listDataMarketing}
                        customStyles={customStyles}
                        pagination
                        paginationPerPage={itemsPerPage}
                        onChangePage={handlePageChange}
                        highlightOnHover
                        pointerOnHover
                      />
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <style>{`
    .fw-800 { font-weight: 800; }
    .rounded-xl { border-radius: 20px !important; }
    .rounded-lg { border-radius: 12px !important; }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06); }
    .bg-light-blue { background-color: #f0f9ff; }
    
    /* Styling khusus untuk ReactDatetime agar matching */
    .rdtPicker { 
      border-radius: 12px !important; 
      border: 1px solid #e2e8f0 !important;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
      padding: 10px !important;
    }
    .rdtDay:hover { background: #577d86 !important; color: white !important; border-radius: 5px; }
    .rdtActive { background: #577d86 !important; color: white !important; border-radius: 5px; }
    
    /* Animation Pulse */
    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s infinite; }

    /* Table Container Styling */
    .rdt_Table { border: 1px solid #f1f5f9; border-radius: 15px; }
  `}</style>
        </Container>
      ) : (
        <>
          <ListMarketingByGetMarketing
            data={sendDataMarketing}
            cabang={sendDataCabang}
          />
        </>
      )}
    </>
  );
}

export default CabangKunjunganMarketing;
